<script>
import { VueDraggableNext } from 'vue-draggable-next'
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { upcomingTasks, progressTasks, completedTasks } from "../atendimento/data-kanaban";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment/moment";
import Pusher from 'pusher-js';
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";


const pusher = new Pusher('26808d2b9868c5aff305', {
  cluster: 'us2',
  encrypted: true,
});

export default {
  page: {
    title: "Chamados",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    draggable: VueDraggableNext,
    Layout,
    PageHeader, Loader
  },
  data() {
    return {
      enabled: true,
      list: [
        { name: 'John', id: 1 },
        { name: 'Joao', id: 2 },
        { name: 'Jean', id: 3 },
        { name: 'Gerard', id: 4 },
      ],
      dragging: false,
      upcomingTasks: upcomingTasks,
      progressTasks: progressTasks,
      completedTasks: completedTasks,
      title: "Chamados",
      items: [
        {
          text: "Atendimento",
          href: "/atendimentos/listprod",
        },
        {
          text: "Chamados",
          active: true,
        },
      ],
      items1: Array(5)
          .fill({})
          .map((_, index) => ({ title: `Item ${index + 1}` })),
      items2: [],

      chatsDataGeral: null,
      chatsDataFechado: null,
      updating: true,

      showModalZapConect: false,
      statusZapConnect: 'NC',
      updatingStatusZap: false,
      qrZap: '',


      troncoSelecionado: null,
      chatsTroncos: null,
      showModalAlteraNomeTronco: false,

      nomeTroncoAtual: '',
      submmitedNomeTronco: false,
      qrCodeSvg: null

    };
  },

  mounted() {
    console.log('chats-list-mounted')
    const channel = pusher.subscribe('whatsceleiro');
    channel.bind('new-message', this.pusherMessage)
    this.carregarDados()

  },



  methods: {

    alteraNomeTronco() {
      console.log('alteraNomeTronco')
      this.showModalAlteraNomeTronco = true
    },


    confAlteraNomeTronco() {
      console.log('confAlteraNomeTronco')
      api.post(`${getBaseUrl()}api/chatnomtrc`, {
        iddata: this.troncoSelecionado,
        descricao: this.nomeTroncoAtual
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)

        this.chatsTroncos = res.data[0]

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Chamado encerrado com sucesso",
          showConfirmButton: false,
          timer: 1500
        })
      })
      this.showModalAlteraNomeTronco = false
    },


    alteraTroncoSelected() {
      console.log('alteraTroncoSelected')
      //console.log()
      this.chatsTroncos.forEach((value) => {
        // console.log('value')
        // console.log(value.id)
        // console.log(this.troncoSelecionado)
        if (value.id === this.troncoSelecionado) {
          this.nomeTroncoAtual = value.descricao
        }
      })
      this.carregarDados()
    },

    carregarDados() {
      this.updating = true
      api.get(`${getBaseUrl()}api/chatmsgs`, {
        params: {
          'tronco': this.troncoSelecionado
        }
      }).then((res) => {
        console.log('then axios chatmsgs')
        console.log(res.data)


        this.chatsTroncos = res.data[2]


        let emAberto = []
        let fechados = []
        this.statusZapConnect = res.data[1]
        res.data[0].forEach((value) => {
          value.created_at = moment(value.created_at).format('DD/MM/YYYY HH:mm:ss')
          if (value.status === 'AB') {
            emAberto.push(value)
          } else {
            fechados.push(value)
          }
        })



        this.chatsDataGeral = emAberto
        this.chatsDataFechado = fechados
        this.updating = false
      })
    },


    pusherMessage(data){
      console.log('pusherMessage')
      console.log(data)

      if (data.message === 'msgsloaded') {

        this.carregarDados()

      } else if (data.message === 'logout') {
        this.statusZapConnect = 'NC'
        Swal.fire({
          text: "Logout efetuado com sucesso",
          icon: "warning",
          position: "top-end",
          showConfirmButton: false,
          timer: 1500
        })
      } else if (data.message === 'clientReady') {
        this.statusZapConnect = 'CN'
        this.showModalZapConect = false


        // this.carregarDados()

        Swal.fire({
          text: "Cliente Whatsapp Conectado, carregando mensagens",
          icon: "success",
          position: "top-end",
          showConfirmButton: false,
          timer: 2500
        })

        this.updating = true

        api.get(`${getBaseUrl()}api/chatloadmsgs`).then((res) => {
          console.log('then axios chatmsgs')
          console.log(res.data)
          this.chatsDataGeral = res.data[0]
          // this.statusZapConnect = res.data[1]
          this.chatsDataGeral.forEach((value) => {
            value.created_at = moment(value.created_at).format('DD/MM/YYYY HH:mm:ss')
          })
          this.updating = false

          // window.setInterval(function(){
          //   console.log('10 segundos')
          //   // console.log(this.statusZapConnect)
          //   if (!this.statusZapConnect) {
          //     api.get(`${getBaseUrl()}api/chatconstatus`).then((res) => {
          //       console.log('then axios timer')
          //       console.log(res.data)
          //
          //       this.statusZapConnect = res.data
          //
          //
          //     })
          //   }
          // }, 1000)



        })


      }





    },

    logoutZap() {
      console.log('logoutZap')
      // this.updating = true

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Logout Whatsapp",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {

          api.get(`${getBaseUrl()}api/chatlogout`).then((res) => {
            console.log('then axios chatlogout')
            console.log(res.data)

            this.chatsDataGeral = null
            this.chatsDataFechado =  null


            // this.chatsDataGeral = res.data[0]
            // this.statusZapConnect = res.data[1]
            // this.chatsDataGeral.forEach((value) => {
            //   value.created_at = moment(value.created_at).format('DD/MM/YYYY HH:mm:ss')
            // })

            //this.updating = false
          })


        }
      })





    },


    carregarChats() {
      console.log('carregarChats')
      //this.carregarDados()

      api.get(`${getBaseUrl()}api/chatloadmsgs`, {
        params: {
          'tronco': this.troncoSelecionado
        }
      }).then((res) => {
        console.log('then axios chatmsgs')
        console.log(res.data)
        this.chatsDataGeral = res.data[0]
        this.statusZapConnect = res.data[1]
        this.chatsDataGeral.forEach((value) => {
          value.created_at = moment(value.created_at).format('DD/MM/YYYY HH:mm:ss')
        })
        this.updating = false

        // window.setInterval(function(){
        //   console.log('10 segundos')
        //   // console.log(this.statusZapConnect)
        //   if (!this.statusZapConnect) {
        //     api.get(`${getBaseUrl()}api/chatconstatus`).then((res) => {
        //       console.log('then axios timer')
        //       console.log(res.data)
        //
        //       this.statusZapConnect = res.data
        //
        //
        //     })
        //   }
        // }, 1000)



      })


    },

    //
    // gerarNovoCodigo() {
    //   this.updatingStatusZap = true
    //
    //   api.get(`${getBaseUrl()}api/chatstatus`, {
    //     responseType: 'blob'
    //   }).then((res) => {
    //     console.log('then axios chatstatus')
    //     // console.log(res.data)
    //     //this.qrZap = res.data
    //
    //     console.log(res)
    //     this.blobUrlWhite = URL.createObjectURL(res.data)
    //
    //     this.updatingStatusZap = false
    //   })
    //
    // },


    consultaStatusZap() {
      console.log('consultaStatusZap')
      if (this.statusZapConnect === 'NC') {
        this.showModalZapConect = true
        this.updatingStatusZap = true

        api.get(`${getBaseUrl()}api/chatstatus`, {
          params: {
            'tronco': this.troncoSelecionado
          }
        }, {
          responseType: 'blob'
        }).then((res) => {
          console.log('then axios chatstatus')
          // console.log(res.data)
          this.qrCodeSvg = res.data
          this.updatingStatusZap = false
        })
      }
    },


    abrirChatDetalhe(dataID){
      console.log('abrirChatDetalhe')
      console.log(dataID)
      this.$router.push(`/atendimento/detalhes/${dataID}`)
    },


    nomeStatus(strEntr){
      let result = strEntr
      switch (strEntr) {
        case 'AB':
          result = 'Em Aberto'
          break
        case 'EC':
          result = 'Encerrado'
          break
      }
      return result
    },


    iniciaisNome(strEntr) {
      // console.log('strEntr')
      // console.log(strEntr)
      if (strEntr) {
        var strEntrArray = strEntr.split(' ')
        // console.log(strEntrArray)
        let iniciais = ''
        for(let i = 0; i < strEntrArray.length; i = i + 1 ) {
          // console.log('[for]', strEntrArray[i][0]);
          if (strEntrArray[i][0]){
            iniciais += strEntrArray[i][0].toUpperCase()
          }
        }
        return iniciais
      } else {
        return 'ND'
      }



    },


    log(event) {
      console.log(event)
    },


  },


};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="statusZapConnect" @click="consultaStatusZap"/>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>

    <div class="row" v-if="!updating" >

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectTronco"
                        v-model="troncoSelecionado"
                        @change="alteraTroncoSelected"
                        class="form-control select2-search-disable">
                      <option v-for="(item, index) in chatsTroncos"
                              :value="item.id"
                              :key="index">
                        {{ item.descricao }}
                      </option>

                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>



              <b-button variant="outline-success" class="mx-2" @click="carregarChats" v-if="statusZapConnect && statusZapConnect === 'CN'">
                <i class="bx bx-sync font-size-16 align-middle me-2"></i>
                Carregar Chats
              </b-button>


              <b-button variant="outline-danger" class="mx-2" @click="logoutZap" v-if="statusZapConnect && statusZapConnect === 'CN'  ">
                <i class="bx bx-exit font-size-16 align-middle me-2"></i>
                Logout
              </b-button>

              <div class="col-sm-2" >

                <b-dropdown ngbDropdown
                            v-if="nomeTroncoAtual && nomeTroncoAtual !== ''"
                            menu-class="dropdown-menu-md dropdown-menu-end"
                            right
                            variant="light">
                  <template v-slot:button-content>
                    <i class="mdi mdi-help me-1"></i>
                    <span class="d-none d-sm-inline-block" ngbDropdownToggle>
                      Auxiliar
                      <i class="mdi mdi-chevron-down"></i>
                    </span>
                  </template>


                  <div >

                    <a class="dropdown-item text-primary text-center"
                       @click="alteraNomeTronco"
                       href="javascript: void(0);">
                      Alterar Nome Funil
                    </a>

                  </div>

                </b-dropdown>
              </div>



              <div class="flex-grow-1 align-self-center">
                <div class="text-muted">
                  <!--                  <h5>R$ 4.855.745,00 (recebíveis hoje)</h5>-->
                  <!--                  <p class="mb-1">R$ 978.444,00 a pagar hoje</p>-->
                  <!--                  <p class="mb-0">Id no: #SK0234</p>-->
                </div>
              </div>



            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="drag-container" v-if="!updating">
      <div class="row drag-list">
        <div class="col-lg-4 drag-column">
          <div class="card">
            <div class="card-body">
              <!-- dropdown -->
              <b-dropdown
                  right
                  variant="white"
                  class="float-end"
                  menu-class="dropdown-menu-end"
                  toggle-class="p-0"
              >
                <template #button-content>
                  <i class="mdi mdi-dots-vertical m-0 text-muted h5"></i>
                </template>
                <b-dropdown-item href="javascript: void(0);"
                >Editar</b-dropdown-item
                >
                <b-dropdown-item href="javascript: void(0);"
                >Outros</b-dropdown-item
                >
              </b-dropdown>
              <span class="drag-column-header">
                <h4 class="card-title mb-4 pb-1">Chamados em Aberto</h4>
              </span>

              <!--              <draggable-->
              <!--                  v-model="items1"-->
              <!--                  transition="100"-->
              <!--                  class="drop-zone"-->
              <!--              >-->
              <!--                <template v-slot:item="{ item }">-->
              <!--                  <div class="draggable-item">-->
              <!--                    {{ item.title }}-->
              <!--                  </div>-->
              <!--                </template>-->
              <!--              </draggable>-->

              <draggable class="list-group"  v-model="upcomingTasks" :draggable="false">
                <div
                    v-for="chat in chatsDataGeral"
                    :key="chat.id"
                    class="card task-box"
                >
                  <div class="card-body">
                    <div class="float-end ml-2">
                      <span
                          class="badge rounded-pill font-size-12"
                          :class="{
                          'badge-soft-secondary': `${chat.tipo}` === 'chat',
                          'badge-soft-success': `${chat.tipo}` === 'Botoes',
                          'badge-soft-primary': `${chat.tipo}` === 'Imagem',
                          'badge-soft-warning': `${chat.tipo}` === 'Link',
                        }"
                      >{{ chat.tipo }}</span
                      >
                    </div>


                    <div>
                      <h5 class="font-size-15">
                        <a href="javascript: void(0);" @click="abrirChatDetalhe(chat.id)"  class="text-dark">
                          Chamado {{ chat.id }}
                        </a>
                      </h5>
                    </div>
                    <p class="text-muted mb-4">{{ chat.created_at }}</p>
                    <div class="avatar-group float-start">


                      <div class="avatar-xs">

                        <span class="avatar-title rounded-circle">
                          {{ iniciaisNome(chat.nome) }}
                        </span>

                      </div>

                      <h5 class="mb-4 ms-2 pb-1">{{ chat.nome }}</h5>

                      <!--                      <div class="avatar-group-item">-->
                      <!--                        <a href="javascript: void(0);" class="d-inline-block">-->
                      <!--                          <img-->
                      <!--                              :src="`${task.user[0]}`"-->
                      <!--                              class="rounded-circle avatar-xs"-->
                      <!--                              alt-->
                      <!--                          />-->
                      <!--                        </a>-->
                      <!--                      </div>-->
                      <!--                      <div class="avatar-group-item" v-if="task.user[1]">-->
                      <!--                        <a href="javascript: void(0);" class="d-inline-block">-->
                      <!--                          <img-->
                      <!--                              :src="`${task.user[1]}`"-->
                      <!--                              class="rounded-circle avatar-xs"-->
                      <!--                              alt-->
                      <!--                          />-->
                      <!--                        </a>-->
                      <!--                      </div>-->
                    </div>
                    <div class="text-end">
                      <h5 class="font-size-15 mb-1"> {{ chat.contmsg }}</h5>
                      <p class="mb-0 text-muted"> {{ nomeStatus(chat.status) }} </p>
                    </div>
                  </div>
                </div>
              </draggable>
<!--              <div class="text-center d-grid">-->
<!--                <a href="javascript: void(0);" class="btn btn-primary mt-3 disabled">-->
<!--                  <i class="mdi mdi-plus me-1"></i> Adicionar Novo-->
<!--                </a>-->
<!--              </div>-->
            </div>
          </div>
        </div>
        <!-- end col-->

        <div class="col-lg-4 drag-column">
          <div class="card">
            <div class="card-body">
              <!-- dropdown -->
              <b-dropdown
                  right
                  variant="white"
                  class="float-end"
                  toggle-class="p-0"
                  menu-class="dropdown-menu-end"
              >
                <template #button-content>
                  <i class="mdi mdi-dots-vertical m-0 text-muted h5"></i>
                </template>
                <b-dropdown-item href="javascript: void(0);"
                >Editar</b-dropdown-item
                >
                <b-dropdown-item href="javascript: void(0);"
                >Outros</b-dropdown-item
                >
              </b-dropdown>
              <span class="drag-column-header">
                <h4 class="card-title mb-4 pb-1">Chamados Encerrados</h4>
              </span>
              <div class="flex m-10">
                <draggable class="list-group"  v-model="upcomingTasks" :draggable="false">
                  <div
                      v-for="chat in chatsDataFechado"
                      :key="chat.id"
                      class="card task-box"
                  >
                    <div class="card-body">
                      <div class="float-end ml-2">
                      <span
                          class="badge rounded-pill font-size-12"
                          :class="{
                          'badge-soft-secondary': `${chat.tipo}` === 'chat',
                          'badge-soft-success': `${chat.tipo}` === 'Botoes',
                          'badge-soft-primary': `${chat.tipo}` === 'Imagem',
                          'badge-soft-warning': `${chat.tipo}` === 'Link',
                        }"
                      >{{ chat.tipo }}</span
                      >
                      </div>


                      <div>
                        <h5 class="font-size-15">
                          <a href="javascript: void(0);" @click="abrirChatDetalhe(chat.id)"  class="text-dark">
                            Chamado {{ chat.id }}
                          </a>
                        </h5>
                      </div>
                      <p class="text-muted mb-4">{{ chat.created_at }}</p>
                      <div class="avatar-group float-start">


                        <div class="avatar-xs">

                        <span class="avatar-title rounded-circle">
                          {{ iniciaisNome(chat.nome) }}
                        </span>

                        </div>

                        <h5 class="mb-4 ms-2 pb-1">{{ chat.nome }}</h5>

                        <!--                      <div class="avatar-group-item">-->
                        <!--                        <a href="javascript: void(0);" class="d-inline-block">-->
                        <!--                          <img-->
                        <!--                              :src="`${task.user[0]}`"-->
                        <!--                              class="rounded-circle avatar-xs"-->
                        <!--                              alt-->
                        <!--                          />-->
                        <!--                        </a>-->
                        <!--                      </div>-->
                        <!--                      <div class="avatar-group-item" v-if="task.user[1]">-->
                        <!--                        <a href="javascript: void(0);" class="d-inline-block">-->
                        <!--                          <img-->
                        <!--                              :src="`${task.user[1]}`"-->
                        <!--                              class="rounded-circle avatar-xs"-->
                        <!--                              alt-->
                        <!--                          />-->
                        <!--                        </a>-->
                        <!--                      </div>-->
                      </div>
                      <div class="text-end">
                        <h5 class="font-size-15 mb-1"> {{ chat.contmsg }}</h5>
                        <p class="mb-0 text-muted"> {{ nomeStatus(chat.status) }} </p>
                      </div>
                    </div>
                  </div>
                </draggable>
              </div>

<!--              <div class="text-center d-grid">-->
<!--                <a href="javascript: void(0);" class="btn btn-primary mt-3 disabled">-->
<!--                  <i class="mdi mdi-plus me-1"></i> Adicionar Novo-->
<!--                </a>-->
<!--              </div>-->
            </div>
          </div>
        </div>
        <!-- end col-->

        <div class="col-lg-4 drag-column">
          <div class="card">
            <div class="card-body">
              <!-- dropdown -->
              <b-dropdown
                  right
                  variant="white"
                  class="float-end"
                  toggle-class="p-0"
                  menu-class="dropdown-menu-end"
              >
                <template #button-content>
                  <i class="mdi mdi-dots-vertical m-0 text-muted h5"></i>
                </template>
                <b-dropdown-item href="javascript: void(0);"
                >Editar</b-dropdown-item
                >
                <b-dropdown-item href="javascript: void(0);"
                >Outros</b-dropdown-item
                >
              </b-dropdown>
              <span class="drag-column-header">
                <h4 class="card-title mb-4 pb-1">Horário de Funcionamento</h4>
              </span>

<!--              <div class="text-center d-grid">-->
<!--                <a href="javascript: void(0);" class="btn btn-primary mt-3 disabled">-->
<!--                  <i class="mdi mdi-plus me-1"></i> Adicionar Novo-->
<!--                </a>-->
<!--              </div>-->
            </div>
          </div>
        </div>

      </div>
    </div>


    <b-modal size="md" title="Status Conexão Whatsapp" v-model="showModalZapConect" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">

          <label for="statusZapConnect">Status atual:
            <span class="text-danger" v-if="statusZapConnect === 'Não Conectado'">
            NÃO CONECTADO {{ statusZapConnect }}
            </span>
            <span class="text-success" v-if="statusZapConnect === 'Conectado'">
            CONECTADO {{ statusZapConnect }}
            </span>
          </label>

        </div>
      </div>
      <div class="row text-center ">

        <Loader v-if="updatingStatusZap" style="min-height: 300px;">
        </Loader>



        <div v-html="qrCodeSvg" ></div>

<!--        <qr-code v-if="!updatingStatusZap"-->
<!--                 size="500"-->
<!--                 :text="qrZap">-->
<!--        </qr-code>-->


      </div>
      <div class="text-end mt-5">
<!--        <b-button variant="light" @click="gerarNovoCodigo" :disabled="updatingStatusZap">-->
<!--          <i class="bx bx-sync font-size-16 align-middle me-2"></i>-->
<!--          Novo Código-->
<!--        </b-button>-->
        <b-button type="submit" variant="success" class="ms-1" @click="showModalZapConect = false">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
      </div>
    </b-modal>




    <b-modal size="md" title="Alterar Nome Funil" v-model="showModalAlteraNomeTronco" centered hide-footer>

      <div class="row text-center ">

        <div class="col-lg-12">
          <div class="mb-3">
            <label for="descNomeTronco">Nome Atual</label>
            <div class="position-relative">
              <input
                  id="descNomeTronco"
                  v-model="nomeTroncoAtual"
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': submmitedNomeTronco && !nomeTroncoAtual }"/>
              <div v-if="submmitedNomeTronco && !nomeTroncoAtual" class="invalid-feedback">
                <span>Campo título obrigatório, favor preencher.</span>
              </div>
            </div>
          </div>
        </div>

      </div>


      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalAlteraNomeTronco = false" :disabled="updatingStatusZap">
          <i class="bx bx-sync font-size-16 align-middle me-2"></i>
          Novo Código
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confAlteraNomeTronco">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
      </div>
    </b-modal>


  </Layout>
</template>
